import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import { sendMapEvent } from "@/utils/analytics";
export var logEvent = function logEvent(key, result) {
  try {
    var data = result.data,
        meta = result.meta;
    var code = meta.code,
        message = meta.message;

    var error_message = message || _JSON$stringify(data);

    sendMapEvent("face_" + key, {
      error_code: code ? code.toString() : "1001",
      error_message: error_message
    });
  } catch (error) {//
  }
};